import type { Locale, SectorDefinition, SectorDomain, Theme } from '../types';
import { chrome, formatDataDate } from '../i18n';
import { PlatformBar } from '../components/PlatformBar';
import { Breadcrumb } from '../components/Breadcrumb';
import { KpiGrid } from '../components/KpiGrid';
import { ChartPanel } from '../components/ChartPanel';
import { icon } from '../components/Icon';
import { FilterControls } from '../components/FilterControls';
import type { SegmentSelection } from '../core/segments';

interface Props {
  sectors: SectorDefinition[];
  active: SectorDefinition;
  domain: SectorDomain;
  locale: Locale;
  theme: Theme;
  selection: SegmentSelection;
  hasCommitments: boolean;
}

/** Tier 3 — sub-category detail: the domain's KPIs and charts. */
export function DomainView({ sectors, active, domain, locale, theme, selection, hasCommitments }: Props): string {
  const c = chrome(locale);
  const content = active.content[locale];

  const kpis = content.kpis.filter((k) => domain.kpis.includes(k.id));
  const charts = content.charts.filter((ch) => domain.charts.includes(ch.id));

  // span layout: 1 chart -> full; 2 charts -> 8/4
  const chartRow =
    charts.length === 0
      ? ''
      : charts.length === 1
        ? `<section class="grid cols" style="margin-top:16px">${ChartPanel(charts[0], 'span12', false, c.recHint)}</section>`
        : `<section class="grid cols" style="margin-top:16px">${ChartPanel(charts[0], 'span8', false, c.recHint)}${ChartPanel(charts[1], 'span4', true, c.recHint)}</section>`;

  return `
    ${PlatformBar(sectors, active.id, locale, theme, hasCommitments, formatDataDate(locale, active.updatedAt))}
    ${Breadcrumb([
      { label: c.navNational, href: 'national', icon: 'gauge' },
      { label: content.navLabel, href: active.id, icon: active.icon },
      { label: domain.name, icon: domain.icon },
    ])}
    <section class="toolbar">
      <div class="domain-head"><span class="ic" style="background:${active.accent}22;color:${active.accent}">${icon(domain.icon, 'icon icon-kpi')}</span>
        <div><b>${domain.name}</b><span>${domain.subtitle}</span></div>
      </div>
      <div class="filter-group">
        ${FilterControls(content, locale, selection)}
      </div>
    </section>
    ${KpiGrid(kpis, locale)}
    ${chartRow}
    <div id="modal-root"></div>`;
}
